<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Confirm Action</p>
        <span
          class="icon is-right"
          @click="closeModal">
          <font-awesome-icon :icon="['fal', 'times']" />
        </span>
      </header>
      <section class="modal-card-body">
        <div class="modal-body">
          When this request processes, all existing potential matches will be
          removed from the queue for this SNAP Match Type.
          Only one SNAP Match Type can run at a time. Are you sure you want to continue?
        </div>
        <div class="update-box">
          <a @click="closeModal">Cancel</a>
          <button
            class="button is-primary"
            @click="confirm">
              Run DC Extended Match
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTimes,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faTimes,
);

export default {
  methods: {
    async confirm() {
      this.$emit('confirm');
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style lang="sass" scoped>
  .modal-card-head
    background-color: #F5F5F5
    text-align: left
  .modal-card-title
    margin-bottom: 0 !important
  .modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
    text-align: left
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
  .update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
</style>
